import * as React from 'react';

import { cn } from '@/lib/utils';

interface CenteredPageLayoutProps extends React.ComponentProps<'div'> {
  title?: string;
}

function CenteredPageLayout({ className, children, title, ...props }: CenteredPageLayoutProps) {
  return (
    <div className={cn('max-w-6xl mx-auto px-6 py-8', className)} {...props}>
      {title && <h1 className="text-center font-raleway text-data-card-2xl mb-8">{title}</h1>}
      {children}
    </div>
  );
}

export { CenteredPageLayout };
